<template>
    <div class="app-container">

        <el-card class="search-form-card">

            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字" class="common-input"></el-input>
                    <el-button type="primary" @click='loadData'>搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>

            <div slot="header">
                <router-link  :to="{ path:'/configurationUpdata', query: { callback: request } }" >
                    <el-button type="primary" v-w-role="'ITSM-0094'">新增配置项</el-button>
                </router-link>
            </div>

            <el-table :data="tableData" style="width: 100%" stripe v-loading='loading'>

                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="所属公司" prop="company">
                    <template slot-scope='scope'>
                        {{scope.row.company.title}}
                    </template>
                </el-table-column>

                <el-table-column label="分类" prop="category"></el-table-column>

                <el-table-column label="配置项编号" prop="serialNumber"></el-table-column>

                <el-table-column label="配置项名称" prop="title"></el-table-column>

                <el-table-column label="配置项状态" prop="status">
                    <template slot-scope='scope'>
                        {{ scope.row.status | tableVal(cmdbStatus) }}
                    </template>
                </el-table-column>

                <el-table-column label="型号" prop="model"></el-table-column>

                <el-table-column label="创建时间" prop="createTime"></el-table-column>

                <el-table-column label="操作" >

                    <template slot-scope="scope">

                        <router-link  :to="{ path:'/configurationUpdata', query: { callback:request, type: 'edit', serialNumber:scope.row.serialNumber } }">
                            <el-button type='text'>编辑</el-button>
                        </router-link>

                        <router-link  :to="{ path:'/configurationDetail', query: { serialNumber: scope.row.serialNumber, callback:request } }">
                            <el-button type='text'>详情</el-button>
                        </router-link>

                        <el-button v-w-role="'ITSM-0062'"  class="table-del-btn" @click.native.prevent="deleteRow(scope.$index, tableData, scope.row.serialNumber)" type="text">删除</el-button>

                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页器 -->
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.pageIndex"
             :page-sizes="[10,20, 30, 40]"
             :page-size="form.pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>
        </el-card>

    </div>
</template>

<script>
import services from './configuration.services'
export default {

    data() {
        return {
            form: {
                userName: localStorage.getItem('internalUserid'),
                pageIndex: 1,
                pageSize: 10,
                keyword: ''
            },
            total: 0,
            pageSizes: [10, 20, 30, 40],
            tableData: [],
            loading: true
        }
    },

    computed:{
        dictionary(){
            return this.$store.state.dictionary;
        },
        cmdbStatus(){
            return this.dictionary.cmdb_status;
        },
    },

    mounted() {
        this.request()
    },

    methods: {
        loadData(){
            this.form.pageIndex=1
            this.request()
        },
        // 请求数据
        request() {
            this.tableData = []
            this.loading = true
            services.cmdbdMy(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = +res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 删除列表某一项
        deleteRow(index, rows, serialNumber) {
            this.$confirm('此操作将永久删除该合同, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    services.cmdbdDelete({serialNumber: serialNumber})
                        .then(res => {
                            this.$message.success('删除成功!')
                            rows.splice(index, 1);
                        }).catch(err => this.$message.error(err.message))
                }).catch(() => {
                    this.$message.info('已取消删除');
            });
        },

        // 更新分页器页数
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request();
        },

        // 更新分页器页码
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>

